export default __webpack_public_path__ + "static/media/blank.b707e5a7.png";